export type CheckoutFlowExperimentVariant = 'control' | 'test-committed' | 'test-stepper'

/**
 * Pack-first checkout flow v2 — experimento cerrado el 2026-07-22 dejando
 * `test-committed` al 100%.
 *
 * La variante se resuelve en local en lugar de leer el flag `pack-first-flow-v2`:
 * evaluarlo emitía `$feature_flag_called` y `$experiment_exposure` en cada vista
 * (~200.000 eventos/mes) para devolver siempre el mismo valor. Además elimina el
 * salto visual entre el layout antiguo y el pack-first mientras cargaban las flags.
 *
 * Para retomar el experimento, volver a `useFeatureFlagVariantKey(PACK_FIRST_FLOW_FLAG)`.
 */
const RESOLVED_VARIANT: CheckoutFlowExperimentVariant = 'test-committed'

export function useCheckoutFlowExperiment() {
  const isPackFirstFlow = computed<boolean>(() => true)

  const isCommittedHourSummary = computed<boolean>(() => RESOLVED_VARIANT === 'test-committed')

  const isThreeStepStepper = computed<boolean>(() => RESOLVED_VARIANT === 'test-stepper')

  const experimentVariant = computed<CheckoutFlowExperimentVariant>(() => RESOLVED_VARIANT)

  return { isPackFirstFlow, isCommittedHourSummary, isThreeStepStepper, experimentVariant }
}
